<script setup lang="ts">
import PageTitle from '@/components/PageTitle.vue';
import LogReminder from '@/components/UserCp/LogReminder.vue';
import SortActivities from '@/components/UserCp/SortActivities.vue';
</script>

<template>
	<div class="pt-6 space-y-10">
		<PageTitle>{{ $t('settings.title') }}</PageTitle>
		<div class="grid widescreen:grid-cols-12 gap-6">
			<LogReminder class="col-span-9" />
			<SortActivities class="col-span-9" />
		</div>
	</div>
</template>
